import env from '.env.json';
import axios from 'axios';

export interface ResultAPI {
  success: boolean;
  data: any;
}

export const postRequest = async (path: string, data: any) => {
  const response = await axios({
    method: 'POST',
    url: path,
    data: data,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return response?.data;
}

// Server-side request helper
export const serverRequest = async (
  path: string,
  methodType: string = 'GET',
  token: string = '',
  data: any = {},
  rootUrl = env.URL_API,
): Promise<ResultAPI> => {
  try {
    const response = await axios({
      method: methodType,
      url: `${rootUrl}${path}`,
      data: methodType !== 'GET' ? data : undefined,
      headers: {
        tokenApi: env.API_KEY,
        oorigin: env.ROOT_URL,
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error: any) {
    return {
      success: false,
      data: error.response?.data || error.message,
    };
  }
};
